/* eslint-env jquery */
/* global braintree Treehouse BraintreeData */

import AccountReactivator from "./account_reactivator";

export default class PaymentProcessor {
  constructor(method = "credit_card", ccFormValidator, controller) {
    this.method = method;
    this.validator = ccFormValidator;
    this.controller = controller;
    this.config = $("#new_payment_method").data("tokenizer-config");

    if (method !== "stripe") {
      this.cardTokenizer = new Treehouse.CreditCardTokenizer(
        $("#new_payment_method").get(0).id,
        {
          tokenization_key: this.config.tokenization_key,
          merchant_id: this.config.merchant_id,
          environment: BraintreeData.environments[this.config.environment],
        },
        this.success,
        this.error,
      );
    }
  }

  process = () => {
    if (this.method === "paypal") {
      this.processPaypal();
    } else if (this.method === "credit_card") {
      this.processCC();
    } else if (this.method === "stripe") {
      this.success();
    } else if (this.method === "on_file") {
      this.successWithoutPayment();
    }
  }

  processCC = () => {
    this.cardTokenizer.tokenizeCard(
      this.controller.ccNumberTarget.value,
      this.controller.ccMonthTarget.value,
      this.controller.ccYearTarget.value,
      this.controller.cvvTarget.value,
      this.controller.ccPostalCodeTarget.value,
    );
  }

  processPaypal = () => {
    const self = this;
    let paymentReceived = false;

    braintree.setup(this.config.tokenization_key, "custom",
      {
        paypal: {
          headless: true,
          singleUse: false,
          locale: "en_US",
          enableShippingAddress: false,
        },
        dataCollector: { paypal: true },
        onReady: checkout => this.initAuthFlow(checkout),
        onPaymentMethodReceived: (data) => {
          // Prevent multiple payment method received events from being triggered
          if (paymentReceived) return;
          paymentReceived = true;

          $("#new_payment_method").find("[data-braintree-name=payment_method_nonce]").val(data.nonce);
          self.success();
        },
      });
  }

  initAuthFlow = (checkout) => {
    checkout.paypal.initAuthFlow();
  }

  error = () => {
    this.ccFormValidator.displayError($("#credit_card_number"), "There was a problem verifying your payment details.");
    this.controller.enableSubmitBtn();
  }

  success = () => {
    const postalCode = this.hasStripePostalCodeTarget ? this.ccPostalCodeTarget.value :  "";
    const reactivator = new AccountReactivator(
      this.controller.data.get("id"),
      this.controller.data.get("billingPeriod"),
      this.controller.data.get("discountCode"),
      $("#new_payment_method").find("[data-braintree-name=payment_method_nonce]").val(),
      postalCode,
      this.method === "on_file",
      this.controller,
      this.controller.data.get("gateway"),
      this.controller.stripePaymentMethodIdTarget.value
    );
    if (this.controller.data.get("planChoice") === "degree") {
      reactivator.setPlanType("degree");
    } else {
      reactivator.setPlanType("plan");
    }
    reactivator.reactivate();
  }

  successWithoutPayment = () => {
    const reactivator = new AccountReactivator(
      this.controller.data.get("id"),
      this.controller.data.get("billingPeriod"),
      this.controller.data.get("discountCode"),
      null,
      this.controller.ccPostalCodeTarget.value,
      this.method === "on_file",
      this.controller,
    );
    if (this.controller.data.get("planChoice") === "degree") {
      reactivator.setPlanType("degree");
    } else {
      reactivator.setPlanType("plan");
    }
    reactivator.reactivate();
  }
}
